import ApiClient from './ApiClient';

export default class ApiUser {
    static getMe = () => {
        return ApiClient.get({
            url: '/api/me',
        });
    }

    static getUsers = () => {
        return ApiClient.get({
            url: '/api/admin/user',
        });
    }

    static getAdmins = () => {
        return ApiClient.get({
            url: '/api/admin/user?admins=1',
        });
    }

    static activateUser = (id) => {
        return ApiClient.get({
            url: '/api/admin/user/' + id + '/activate/toggle',
        });
    }

    static resetUserPassword = (id) => {
        return ApiClient.get({
            url: '/api/admin/user/' + id + '/reset',
        });
    }

    static undeleteUser = (id) => {
        return ApiClient.get({
            url: '/api/admin/user/' + id + '/undelete',
        });
    }

    static updateUser = (id, data) => {
        return ApiClient.patch({
            body: data,
            url: '/api/admin/user/' + id,
        });
    }

    static payeeUser = (id) => {
        return ApiClient.get({
            url: '/api/admin/user/' + id + '/payee/toggle',
        });
    }

    static adminUser = (id) => {
        return ApiClient.get({
            url: '/api/admin/user/' + id + '/admin/toggle',
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiUser.js